import React, {useEffect, useState} from 'react';
import {getLocalUser, removeLocalUser, saveLocalUser} from '../article/oauth/userStorage';
import _ from 'lodash';
import {wxAuth} from '@/api/wxAuth';
import {Spin} from 'antd';

export default function WxAuthPage() {
    const [value, setValue] = useState('等待跳转');
    useEffect(() => {
        const codeInfo = getLocalUser();
        if (!_.isEmpty(codeInfo) && codeInfo.id && codeInfo.id === window.location.search.split('&')[0].substring(6)) {
            window.location.href = codeInfo.mask;
        } else {
            init();
        }
    }, [window.location.href]);

    const init = () => {
        setValue('等待跳转');
        console.log(window.location);
        let path1 = window.location.pathname.split('/');
        let path2 = window.location.search.split('&');
        console.log(path2, path1);
        const postData = {
            accessCode: parseInt(path1[3]),
            base64Url: path1[4],
            scope: path1[5],
            resultType: path1[6],
            // weixinInfo: path1[7],
            code: path2[0].substring(6),
            state: path2[1].substring(6),
        };
        // let postData = {};
        console.log(postData);
        wxAuth(postData)
            .then(res => {
                saveLocalUser(path2[0].substring(6), path2[1].substring(6), res.data);
                window.location.href = res.data;
                // alert(JSON.stringify(res));
                // let key = Object.keys(res.response.data)[0];
                // if (key == 301) {
                //     window.location.href = res.response.data[key];
                // } else {
                //     setValue(res.response.data[key]);
                // }
                // window.location.href = res.get(301);
                // alert(JSON.stringify(res));
            })
            .catch(e => {
                // alert(JSON.stringify(e));
            })
            .finally(() => {
                // window.location.href =
                //     'https://anytech.cn/?authStatus=40029&authMessage=invalid+code%2C+hint%3A+%5B1657360573431491789501232%5D%2C+from+ip%3A+101.87.103.174%2C+more+info+at+https%3A%2F%2Fopen.work.weixin.qq.com%2Fdevtool%2Fquery%3Fe%3D40029';
                //
            });
    };
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100vw',
                height: '100vh',
            }}
        >
            <Spin size="large" />
        </div>
    );
}
